'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseHeadings = require('@bibliocommons/base-headings');

var _reactIntl = require('react-intl');

require('@bibliocommons/bootstrap/scss/mixins/_links.scss');

require('@bibliocommons/bootstrap/scss/mixins/_branding.scss');

require('@bibliocommons/bootstrap/scss/mixins/_typography.scss');

require('../style/CardBody.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CardBody = function (_React$Component) {
  _inherits(CardBody, _React$Component);

  function CardBody() {
    _classCallCheck(this, CardBody);

    return _possibleConstructorReturn(this, (CardBody.__proto__ || Object.getPrototypeOf(CardBody)).apply(this, arguments));
  }

  _createClass(CardBody, [{
    key: 'renderCreator',
    value: function renderCreator() {
      var _props = this.props,
          creatorName = _props.creatorName,
          creatorUrl = _props.creatorUrl;


      var creatorLinks = creatorUrl ? _react2.default.createElement(
        'a',
        {
          href: creatorUrl,
          className: 'link-solid-true-underline-grey' },
        creatorName
      ) : creatorName;

      return _react2.default.createElement(
        'div',
        { className: 'card-description' },
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_lists_by_creator', values: { creatorLinks: creatorLinks } })
      );
    }
  }, {
    key: 'renderDescription',
    value: function renderDescription() {
      var description = this.props.description;

      return description && _react2.default.createElement(
        'p',
        { className: 'card-description' },
        description
      );
    }
  }, {
    key: 'renderTags',
    value: function renderTags() {
      var tags = this.props.tags.map(CardBody.renderTag).reduce(function (accu, elem) {
        return accu === null ? [elem] : [].concat(_toConsumableArray(accu), [' / ', elem]);
      });

      return _react2.default.createElement(
        'span',
        { className: 'card-tags' },
        tags
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var cardImage = this.props.cardImage;

      return _react2.default.createElement(
        'div',
        { className: 'cp-card-body' },
        cardImage,
        _react2.default.createElement(
          'div',
          { className: 'info' },
          _react2.default.createElement(_baseHeadings.ChevronHeading, { tag: this.props.cardHeadingTag, url: this.props.exitUrl, text: this.props.title, className: 'card-heading' }),
          this.renderCreator(),
          this.renderDescription(),
          this.renderTags()
        )
      );
    }
  }], [{
    key: 'renderTag',
    value: function renderTag(tag) {
      if (tag.url) {
        return _react2.default.createElement(
          'a',
          { className: 'link-solid-faux-underline', href: tag.url },
          tag.label
        );
      }

      return _react2.default.createElement(
        'span',
        null,
        tag.label
      );
    }
  }]);

  return CardBody;
}(_react2.default.Component);

CardBody.propTypes = {
  cardHeadingTag: _react.PropTypes.string,
  title: _react.PropTypes.string.isRequired,
  exitUrl: _react.PropTypes.string,
  creatorName: _react.PropTypes.string,
  creatorUrl: _react.PropTypes.string,
  description: _react.PropTypes.string,
  cardImage: _react.PropTypes.element,
  tags: _react.PropTypes.arrayOf(_react.PropTypes.shape({ label: _react.PropTypes.string.isRequired, url: _react.PropTypes.string }).isRequired)
};

exports.default = CardBody;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/card/base/lib/components/CardBody.js
// module id = 583
// module chunks = 5 9